import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';

const CookiePolicyView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <span dangerouslySetInnerHTML={{ __html: props.htmlMarkup }} />
        </div>
    );
};

export default CookiePolicyView;
global.CookiePolicyView = CookiePolicyView;